import React from 'react';
import Tab from '../webcommon/header/tab/Tab';
import { withRouter } from 'react-router';
// import ImCalculation from './imcalculation/ImCalculation';
import styles from './Summary.module.scss';
import tabStyles from './TabOverride.module.scss';
import WebJobsRouting from './webjobs/WebJobsRouting';
import DailyBatchHist from './dailyBatchHist/DailyBatchHist';
import ImpactAnalysisIdSummary from './impactAnalysisIdSummary/ImpactAnalysisIdSummary';
import FileAvailability from './fileAvailability/fileAvailability';
// import DownloadLogButton from './DownloadLogButton';

export default (withRouter(() => (
    <div className={ styles.summary }>
        <div style={{ background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: 24, paddingRight: 24, paddingTop: 24, paddingBottom: 8 }}>
            <div className={ styles.header }>
                Admin
            </div>
            {/* <DownloadLogButton /> */}
        </div>
        <div className={ styles.tabContainer }>
            <Tab
                rememberLastTab
                styles={ tabStyles }
                tabs={ [
                    {
                        title: 'Web Jobs',
                        path: '/webJobs',
                        component: WebJobsRouting
                    },
                    // {
                    //     title: 'Daily Batch History',
                    //     path: '/dailyBatchHist',
                    //     component: DailyBatchHist
                    // },
                    {
                        title: 'Impact Analysis ID Summary',
                        path: '/idsummary',
                        component: ImpactAnalysisIdSummary
                    },
                    {
                        title: 'File Availability',
                        path: '/fileAvailability',
                        component: FileAvailability
                    }
                    // Hide tab until page complete
                    // {
                    //     title: 'IM Calculation',
                    //     path: '/imcalculation',
                    //     component: ImCalculation
                    // },
                ] }
            />
        </div>
    </div>
)));
